import { useState } from "react";
import { useRouter } from "next/router";
import { storyblokEditable } from "@storyblok/react";
import ahoy from "@lib/ahoy";
import { analytics } from "@lib/trackers/analytics";
import classNames from "classnames";
import { useCurrentUser } from "@hooks/use-current-user";
import CloseButton from "@components/core/CloseButton";
import Link from "@components/core/Link";
import styleVariables from "@utils/styleVariables";

const styles = styleVariables();

function PromoBanner({ blok }) {
  const router = useRouter();
  const user = useCurrentUser();
  const userGroup = user?.user_group || "visitor";

  const [displayPromoBanner, setDisplayPromoBanner] = useState(blok?.show);

  function sendTrackerData() {
    const defaultEventData = {
      tracking_name: "PromoBanner",
      page: router.asPath,
      title: blok.title,
      subtitle: blok.subtitle || "",
      link: blok.link?.url,
      user_group: userGroup,
    };

    ahoy("$click", defaultEventData);
    analytics.track("$click", defaultEventData);
  }

  if (!blok) return null;

  return (
    <div
      key={blok._uid}
      {...storyblokEditable(blok)}
      className={classNames(
        "position-relative justify-content-between align-items-center flex-grow-1",
        displayPromoBanner ? "d-flex" : "d-none",
      )}
      style={{ backgroundColor: blok.background_color || styles.tertiary }}
    >
      <div className="p-3 m-1" />
      <Link
        href={blok.link?.url}
        onClick={() => sendTrackerData()}
        style={{ textDecoration: "none" }}
      >
        <div className="promo-banner-container">
          <section className={`promo-banner-text-section px-0 text-${blok.text_color}`}>
            <h6 className="text-2-lines mb-0">{blok.title}</h6>
            <p
              className="promo-banner-text font-weight-medium font-size-sm mb-0"
              style={{ textDecoration: "underline" }}
            >
              {blok.subtitle}
            </p>
          </section>
        </div>
      </Link>
      <CloseButton
        onClick={() => setDisplayPromoBanner(false)}
        variant={`ghost-${blok.text_color}`}
      />
    </div>
  );
}

export default PromoBanner;
